import { render } from "./FinalCtaSection.vue?vue&type=template&id=2f10d291&scoped=true"
import script from "./FinalCtaSection.vue?vue&type=script&lang=js"
export * from "./FinalCtaSection.vue?vue&type=script&lang=js"

import "./FinalCtaSection.vue?vue&type=style&index=0&id=2f10d291&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f10d291"]])

export default __exports__